import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';

import { ResultChip } from '@components/ResultChip';

import { calculateOverallResults } from '@features/customerReview/utils/calibrationResultCalculators';

import type { CalibrationRuntimeData } from '@features/calibration/hooks/useCalibrationRuntime/types';

type Props = {
  calibrationData: CalibrationRuntimeData;
};

const HistoryResultsSummary: React.FC<Props> = ({ calibrationData }) => {
  const { t } = useTranslation('history');

  const results = useMemo(
    () => calculateOverallResults(calibrationData),
    [calibrationData]
  );

  const overallLabel = results.asLeftPassed ? 'Pass' : 'Fail';

  return (
    <Paper elevation={1} sx={{ p: { xs: 2, sm: 3 }, width: '100%' }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        {t('results.title')}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t('results.overallResult')}:
        </Typography>
        <ResultChip result={overallLabel} />
      </Box>
    </Paper>
  );
};

export default HistoryResultsSummary;
